import {
  Box,
  Flex,
  useRadio,
  useRadioGroup,
  UseRadioProps,
  VStack,
} from "@chakra-ui/react"
import { starIcons } from "@components/Product/Ratings"
import { NumericMenuRenderStateItem } from "instantsearch.js/es/connectors/numeric-menu/connectNumericMenu"
import { ReactNode } from "react"
import { useNumericMenu } from "react-instantsearch-core"

export const ratingsOptions = [
  {
    label: "4",
    start: 4,
  },
  {
    label: "3",
    start: 3,
  },
  {
    label: "2",
    start: 2,
  },
  {
    label: "1",
    start: 1,
  },
  {
    label: "Clear",
  },
]

function RadioButton(props: UseRadioProps & { children: ReactNode }) {
  const { getInputProps, getRadioProps } = useRadio(props)

  const input = getInputProps()
  const radio = getRadioProps()

  return (
    <Box as={"label"}>
      <input {...input} />
      <Box
        {...radio}
        cursor={"pointer"}
      >
        {props.children}
      </Box>
    </Box>
  )
}

function RatingsFilter() {
  const { items, refine } = useNumericMenu({
    attribute: "aggregateRating.ratingValue",
    items: ratingsOptions,
  })

  const handleChange = (value: string) => {
    refine(value)
  }

  const label = (item: NumericMenuRenderStateItem) => {
    if (item.label === "Clear") {
      return (
        <Box
          as={"span"}
          fontWeight={500}
        >
          {item.label}
        </Box>
      )
    } else {
      return (
        <Flex alignItems={"center"}>
          {starIcons(Number(item.label))}
          <Box
            as={"span"}
            ms={1}
            fontWeight={500}
          >
            {"& up"}
          </Box>
        </Flex>
      )
    }
  }

  // Show the "Clear" option only if any other option is selected
  const anyRatingsOption = items.some(
    (item) => item.label !== "Clear" && item.isRefined
  )
    ? items
    : items.filter((item) => item.label !== "Clear")

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "framework",
    defaultValue: "react",
    onChange: handleChange,
  })

  const group = getRootProps()

  return (
    <VStack
      alignItems={"start"}
      {...group}
    >
      {anyRatingsOption.map((item) => {
        const radio = getRadioProps({ item })
        return (
          <RadioButton
            {...radio}
            key={item.value}
            isChecked={item.isRefined}
            value={item.value}
          >
            <Box
              fontSize={"sm"}
              borderRadius={6}
              borderStyle={"solid"}
              borderWidth={1}
              borderColor={item.isRefined ? "yellow.400" : "transparent"}
              px={2}
              py={1}
            >
              {label(item)}
            </Box>
          </RadioButton>
        )
      })}
    </VStack>
  )
}

export default RatingsFilter
